export default "__VITE_ASSET__p6riDY0k__"